import { yupResolver } from "@hookform/resolvers/yup";
import { defaultFormValues as _defaultFormValues, schema } from "./constants";
import { GenerateAdminApiSecretFormValues } from "./types";
import { FormProvider, useForm } from "react-hook-form";

export interface GenerateAdminApiSecretFormProps {
  defaultFormValues?: Partial<GenerateAdminApiSecretFormValues>;
  children?: React.ReactNode;
}
export const GenerateAdminApiSecretForm = ({
  defaultFormValues,
  children,
}: GenerateAdminApiSecretFormProps) => {
  const methods = useForm<GenerateAdminApiSecretFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ..._defaultFormValues,
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
